// extracted by mini-css-extract-plugin
export default {"title":"AssetParamInfo_title__tkYcm","wrapper":"AssetParamInfo_wrapper__VxPTz","info":"AssetParamInfo_info__B+SOI"};